import { useState } from 'react';
import axios from 'axios';

const useFetchActivityData = () => {
  const [loadingFetchActivityData, setFetchActivityData] = useState(false);
  const [errorloadingFetchActivityData, setErrorFetchActivityData] = useState(null);

  const fetchActivityData = async (afeid) => {
    try {
      setFetchActivityData(true);
      setErrorFetchActivityData(null);

      const response = await axios.get(`/api/ProjectActivity/get-activity-by/${afeid}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      setErrorFetchActivityData(err);
      throw err;
    } finally {
      setFetchActivityData(false);
    }
  };

  return { fetchActivityData, loadingFetchActivityData, errorloadingFetchActivityData };
};

export default useFetchActivityData;
